import React, { useEffect, useState } from "react";
import DecorativeSquares from "../../components/ui/DecorativeSquares";
import { useNavigate, useParams } from "react-router-dom";
import Initials from "../../components/Initials/Initials";
import { FiPhoneCall } from "react-icons/fi";
import Ordersheet from "../../components/Orderview/Ordersheet";
import { useDispatch } from "react-redux";
import { getCustomerRecords } from "../../redux/thunks/customerRecordThunk";
import PaymentShimmer from "../../components/Preloader/PaymentShimmer";
import { FaArrowLeft } from "react-icons/fa";
import { decryptId, encryptId } from "../../utils/urlCrypto";

const Orderview = () => {
  const navigate = useNavigate();
  const { customer_id } = useParams();
  const customerId = decryptId(customer_id);
  const dispatch = useDispatch();
  const [customerData, setCustomerData] = useState(null);
  const handleGoBack = () => {
    navigate(`/customers-detail/${encryptId(customerId)}`);
  };

  useEffect(() => {
    const payload = {
      service_provider_customer_id: customerId,
    };
    dispatch(getCustomerRecords(payload))
      .unwrap()
      .then((res) => {
        // console.log("The res of getting the customer records is :", res.data);
        const getCustomerData = res.data;
        setCustomerData(getCustomerData);
      });
  }, [dispatch, customerId]);

  if (!customerData) {
    return <PaymentShimmer />;
  }
  return (
    <>
      <section className="relative max-w-7xl mx-auto px-4 py-6 max-h-screen">
        <DecorativeSquares />
        <div className="sticky top-2 z-10 bg-white/80 backdrop-blur-md rounded-2xl shadow-md px-4 py-3 flex items-center justify-between mb-6">
          <button
            onClick={handleGoBack}
            className="flex items-center p-2 rounded-full hover:bg-gray-100"
          >
            <FaArrowLeft size={20} />
          </button>

          <h1 className="mx-auto text-2xl font-semibold text-gray-900">
            Order history
          </h1>
        </div>
        <div className="px-0 md:px-4 mt-8 space-y-4">
          <div className="mx-auto w-full max-w-7xl bg-white border border-gray-200 rounded-xl  p-2 shadow-sm">
            <div className="flex justify-between">
              <div className="flex items-center gap-4">
                {/* Avatar */}
                <Initials initial={customerData.initials} />
                {/* User Info */}
                <div className="flex flex-col">
                  <h2 className="text-base font-semibold text-gray-900">
                    {customerData.customer_name}
                  </h2>

                  <p className="mt-1 flex items-center gap-2 text-sm text-gray-600">
                    <FiPhoneCall size={10} />+{customerData.country_code}{" "}
                    {customerData.contact_no}
                  </p>
                </div>
              </div>
            </div>

            <div className="border-t border-gray-100 mb-8 mt-8" />

            <div>
              <Ordersheet customerId={customerId} />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Orderview;
